import { Link } from "react-router-dom";

export const article = [
  {
    articleId: 36,
    url: "cargos-no-reconocidos-o-no-autorizados-de-mega-go",
    category: {
      slug:"facturacion",
      name: "Facturación"
    },
    title: "Cargos no reconocidos o no autorizados de Mega GO",
    content: 
      <>
        <div className="row">
          <p>Si ves cargos de Mega GO inesperados en tu estado de cuenta, sigue los siguientes pasos cuando corresponda. </p>
        </div>
        <div className="rowLine">
          <h2>Se te cobró Mega GO, pero no tienes una cuenta </h2>
          <p>Es posible que una persona haya iniciado una cuenta con tu forma de pago. Si nunca te suscribiste a Mega GO o sospechas que alguien está usando tu información de pago para una cuenta de Mega GO sin tu consentimiento, comunícate con nosotros de inmediato. </p>
        </div>
        <div className="rowLine">
          <h2>Se sigue cobrando en una tarjeta vencida</h2>
          <p>Es posible que tu banco haya actualizado la información de tu tarjeta de débito o crédito. Los bancos podrían actualizar automáticamente los números de tarjeta de crédito o débito cuando se emite una nueva tarjeta. Esta actualización permite que se continúe cobrando en la tarjeta, incluso si está vencida. Puedes eliminar o actualizar tu información de pago en cualquier momento en la página Cuenta. </p>
        </div>
        <div className="rowLine">
          <h2>Se te cobró un monto diferente al esperado</h2>
          <p>Consulta <Link to='../article/por-que-cambio-tu-precio-de-mega-go'>Por qué cambió tu precio de Mega GO.</Link></p>
        </div>
        <div className="rowLine">
          <h2>Se te cobró después de cancelar la cuenta</h2>
          <p>Consulta <Link to='../article/se-te-cobro-despues-de-cancelar-mega-go'>Se me cobró después de cancelar Mega GO.</Link></p>
        </div>
        <div>
          <h2>Se te cobró varias veces</h2>
          <p>Consulta <Link to='../article/mega-go-me-cobro-dos-veces'>Mega GO me cobró dos veces.</Link></p>
        </div>
      </>
  }
];